import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ProfileService, SPSmtpService } from '../profile.service';
import { Profile, ProfileForm } from '../model/model.class';
import { NavigationExtras, Router } from '@angular/router';
import { MatSelect, MatSnackBar } from '@angular/material';
import { AppComponentClass } from '../../shared/service/AppComponent.class';
import { ProfileUpload } from '../../app-routing.module';
import { Theme } from '../../shared/service/AutoTheme';

@Component({
  selector: 'app-editprofile',
  templateUrl: './editprofile.component.html',
  styleUrls: ['./editprofile.component.css']
})

export class EditprofileComponent extends AppComponentClass<Profile, ProfileForm> {
  public loader: boolean;
  public spinner: boolean;
  protected form: FormGroup;
  public smssetup: boolean=false;
  public keytype:number;
  public isstate: boolean = false;
  protected timezone_list: any=[]; 
  public Profilepic = ProfileUpload + '/profileupload';
  resend: boolean = false;
  brandid: any;
  
  constructor(protected data: ProfileService,public obdata:SPSmtpService, protected router: Router, protected fb: FormBuilder, protected msg: MatSnackBar, protected theme: Theme) {
    super(data, router, fb, msg);
    this.keyfield = parseInt(sessionStorage.getItem('iduser'));
    this.keytype = parseInt(sessionStorage.getItem('type'));
  }

  ngOnInit(): void {

    this.data.getService("main").subscribe(res => {
      console.log("Profile detailed data",res);
      this.cdata = new ProfileForm(res[0]);      
      this.form = this.cdata.makeform(this.fb);
      this.isstate = true;
      if(res[0].timezone!=null && res[0].timezone!=undefined)
        sessionStorage.setItem("timezone", res[0].timezone);
      else
        sessionStorage.setItem("timezone", "ET");
    },
      err => {
        console.log("error part")
        this.cdata = new ProfileForm(null);
        this.form = this.cdata.makeform(this.fb);
        this.isstate = true;
        sessionStorage.setItem("timezone", "ET");
      });

    /* Get Timezone List */
    this.data.getService("timezone").subscribe(res => {
      this.timezone_list = res;
    });

    /* Get Campaign List */
    this.data.getService("brandcamp").subscribe((res:any) => {
      console.log(res);
      this.obdata.SetData(res)
        this.brandid = res[0].brand_id
      this.smssetup = false;
      if(res[0].status==0){
        this.resend = true
      }else{
        this.resend = false
      }
    },
    err => {
      if(this.keytype == 4)
        this.smssetup = true;
    });

  }

  //accept only numbers 
  ValidateIn(event: any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false
    }
    return true
  }

  onComplete(event: any) {
    this.onSubmit();
    console.log(event);
    console.log("Profilepic uploaded");
    sessionStorage.setItem("profile_image", event.filename);
    this.theme.ChangeProfilePic({ image: event.filename });
    sessionStorage.setItem("profile", JSON.stringify(event));
    this.openSnackBar("Profile Picture Uploaded Successfully", "Clear");
  }

  onSubmit() {
    if (this.cdata.saveForm(this.form)) {
      sessionStorage.setItem('fullname', this.cdata.first_name + " " + this.cdata.last_name);
      sessionStorage.setItem("timezone", this.cdata.timezone);
      super.onSubmit();
    }
  } 

  EnableSMS() {
    // if (this.cdata.agentcode != null && this.cdata.agentcode != undefined && this.cdata.agentcode != "")
    // {
      let navigationExtras: NavigationExtras = {
        queryParams: {
            type: 6
        }
      }
        this.router.navigate ( [ '/smssetup' ], navigationExtras);  
    // }
    // else
    // {
    //   alert("Please update Portal Agent Code.");
    // }
      
  }
  resendOTP(){
    console.log(this.brandid);
    
    this.data.brandSmsOtp(this.brandid).subscribe((res:any)=>{
      console.log(res);
      this.openSnackBar(res.message, "Clear");
    }, err => {
      alert(" Something went wrong.")
    })
  }
}


